// iodd-main.js — Sliding panel sidebar (event binding only, no DOM injection)

document.addEventListener('DOMContentLoaded', function() {
  var menu = document.querySelector('.iodd-main-menu');
  var nav = document.querySelector('.iodd-main-menu--container');
  var toggler = document.querySelector('.iodd-main-menu--mobile-menu-button');

  if (!menu || !toggler) return;

  /* ── Close button (from Liquid) ── */
  var closeBtn = menu.querySelector('.iodd-menu__close');
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  /* ── Panel triggers — open sub-menu on click ── */
  menu.querySelectorAll('[data-panel-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var subMenu = trigger.parentElement.querySelector(':scope > .sub-menu');
      if (subMenu) openPanel(subMenu);
    });
  });

  /* ── Back buttons — close current panel ── */
  menu.querySelectorAll('[data-panel-back]').forEach(function(backBtn) {
    backBtn.addEventListener('click', function() {
      var panel = backBtn.closest('.sub-menu');
      if (panel) closePanel(panel);
    });
  });

  /* ── Panel open/close ── */
  function openPanel(subMenu) {
    subMenu.classList.add('panel-open');
    subMenu.scrollTop = 0;
    updateDepth();
  }

  function closePanel(subMenu) {
    subMenu.classList.remove('panel-open');
    updateDepth();
  }

  function closeAllPanels() {
    menu.querySelectorAll('.sub-menu.panel-open').forEach(function(el) {
      el.classList.remove('panel-open');
    });
    updateDepth();
  }

  function updateDepth() {
    var openPanels = menu.querySelectorAll('.sub-menu.panel-open');
    if (nav) nav.setAttribute('data-panel-depth', openPanels.length);
  }

  /* ── Hamburger toggle ── */
  toggler.setAttribute('aria-expanded', 'false');
  toggler.setAttribute('aria-label', 'Open Menu');

  toggler.addEventListener('click', function() {
    nav && nav.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  document.body.addEventListener('click', function(e) {
    if (e.target === document.body && nav && nav.classList.contains('is-open')) closeMenu();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) closeMenu();
  });

  function openMenu() {
    if (!nav) return;  
    nav.classList.add('is-open');
    toggler.classList.add('open');
    document.body.classList.add('is-active');
    document.documentElement.classList.add('mobile-menu-open');
    document.body.classList.add('no-scroll');
    toggler.setAttribute('aria-expanded', 'true');
    toggler.setAttribute('aria-label', 'Close Menu');
  }

  function closeMenu() {
    if (!nav) return;  
    nav.classList.remove('is-open');
    toggler.classList.remove('open');
    document.body.classList.remove('is-active');
    document.documentElement.classList.remove('mobile-menu-open');
    document.body.classList.remove('no-scroll');
    toggler.setAttribute('aria-expanded', 'false');
    toggler.setAttribute('aria-label', 'Open Menu');

    setTimeout(closeAllPanels, 350);
  }
});